import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import MainLayout from "../../components/layout/MainLayout";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import SubSessionTypeForm from "./SubSessionTypeForm";
import { createSubSessionMaster } from "../../store/slices/subSessionSlice";

const AddSubSessionType = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [formData, setFormData] = useState({
        sessionCategoryMasterId: "",
        sessionMasterId: "",
        department: "",
        name: "",
        description: "",
        status: "active",
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.sessionCategoryMasterId) newErrors.sessionCategoryMasterId = "Session Category is required";
        if (!formData.sessionMasterId) newErrors.sessionMasterId = "Session Type is required";
        if (!formData.department) newErrors.department = "Department is required";
        if (!formData.name.trim()) newErrors.name = "Name is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            Swal.fire({
                title: "Missing Fields",
                text: "Please fill all required fields.",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return;
        }

        try {
            const payload = {
                session_category_master_id: formData.sessionCategoryMasterId,
                session_master_id: formData.sessionMasterId,
                department: formData.department,
                name: formData.name,
                description: formData.description,
                status: formData.status,
            };

            await dispatch(createSubSessionMaster(payload)).unwrap();

            Swal.fire({
                title: "Success!",
                text: "Sub Session Type added successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            navigate("/sub-session-types");
        } catch (err) {
            Swal.fire({
                title: "Error",
                text: err.message || "Failed to add Sub Session Type",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        {Object.keys(errors).length > 0 && (
                            <div className="alert alert-danger">
                                {Object.values(errors).map((err, i) => (
                                    <div key={i}>{err}</div>
                                ))}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <SubSessionTypeForm
                                formData={formData}
                                handleChange={handleChange}
                            />

                            <div className="row mt-3">
                                <div className="col-md-2 ms-auto">
                                    <button type="submit" className="btn btn-primary w-100">
                                        <i className="ri-save-3-line me-1"></i> Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddSubSessionType;
